import { render, staticRenderFns } from "./important_hz_list.vue?vue&type=template&id=560f9df7&scoped=true&"
import script from "./important_hz_list.vue?vue&type=script&lang=js&"
export * from "./important_hz_list.vue?vue&type=script&lang=js&"
import style0 from "./important_hz_list.vue?vue&type=style&index=0&id=560f9df7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560f9df7",
  null
  
)

export default component.exports